import * as types from "./constants";
import postsReducer from "../posts/reducers";
import { reduceReducers } from "../utils";
import update from 'immutability-helper';

const initialState = {
  objects: [],
  fetchingPhotos: true
};

function photosReducer(state=initialState, action) {
  switch (action.type) {
    case types.HYDRATE_PHOTO_POSTS:
      return update(state, {
        objects: {$set: action.objects},
        cursor: {$set: action.cursor},
        more: {$set: action.more},
        fetchingPhotos: {$set: false},
        hydrated: {$set: true}
      });
    case types.ADD_PHOTO_POST:
      return update(state, {
        objects: {$unshift: [action.post]}
      });
    case types.ADD_PHOTO_POSTS:
      return update(state, {
        objects: {$push: action.objects},
        cursor: {$set: action.cursor},
        more: {$set: action.more},
        fetchingPhotos: {$set: false}
      });
    case types.ADD_MULTI_PHOTO_POSTS:
      return update(state, {
        objects: {$unshift: action.objects}
      });
    default:
      return state
  }
}

// We merge the photos reducer with the posts reducer since the posts reducer
// has been abstracted
const reducedPhotosReducer = reduceReducers(photosReducer, postsReducer);

export default reducedPhotosReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/photos/reducers.es6